import { ismatch, ROUTE_CHANGE_EVENT, ORIGIN_PARAM, isAppPath, isOriginState, navigationTarget, routePath, stripQuery, dispatchRouteChange, } from './_common';
const parsePath = (value, basename) => {
    const _raw = value;
    const path = stripQuery(value);
    const withoutBase = basename && (path === basename || path.startsWith(`${basename}/`)) ? path.substring(basename.length) || '/' : path;
    const raw = withoutBase === '' ? '/' : withoutBase;
    const pieces = raw === '/' ? [] : raw.split('/').filter(Boolean);
    return { _raw, raw, pieces, ismatch: ismatch(pieces) };
};
// A ?from= arriving with a document load becomes this entry's origin and leaves the address bar.
const adoptCarriedOrigin = () => {
    const url = new URL(window.location.href);
    const from = url.searchParams.get(ORIGIN_PARAM);
    if (from === null)
        return;
    url.searchParams.delete(ORIGIN_PARAM);
    window.history.replaceState({ from }, '', url.toString());
};
export const createHistoryRoutingStrategy = (basename) => {
    adoptCarriedOrigin();
    return {
        'current': () => parsePath(window.location.pathname, basename),
        'parse': url => parsePath(new URL(url, window.location.origin).pathname, basename),
        'origin': () => {
            const state = window.history.state;
            return isOriginState(state) ? state.from : null;
        },
        'pathToURL': path => `${basename}${routePath(path)}`,
        'navigate': (target, options) => {
            const next = navigationTarget(target);
            if (next.kind === 'hash') {
                window.location.hash = next.value;
                return;
            }
            if (next.kind === 'document') {
                window.location.assign(next.value);
                return;
            }
            if (!isAppPath(window.location.pathname, basename) || !isAppPath(next.url.pathname, basename)) {
                window.location.assign(next.local);
                return;
            }
            // An origin carried in the link is recorded on the entry, never shown in the address bar.
            next.url.searchParams.delete(ORIGIN_PARAM);
            const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
            const destination = `${next.url.pathname}${next.url.search}${next.url.hash}`;
            if (options === null || options === void 0 ? void 0 : options.replace) {
                window.history.replaceState(window.history.state, '', destination);
            }
            else if (destination !== current) {
                window.history.pushState({ 'from': current }, '', destination);
            }
            dispatchRouteChange();
        },
        'listen': (listener) => {
            const onChange = () => listener();
            window.addEventListener('popstate', onChange);
            window.addEventListener('hashchange', onChange);
            window.addEventListener(ROUTE_CHANGE_EVENT, onChange);
            return () => {
                window.removeEventListener('popstate', onChange);
                window.removeEventListener('hashchange', onChange);
                window.removeEventListener(ROUTE_CHANGE_EVENT, onChange);
            };
        },
    };
};
